<template>
<div
      class="container-fluid panel-top opened"
      :class="{
        //opened: showTopPanel,
        //leftopened: showLeftSidebar,
        //rightopened: showExploreSidebar,
        //leftrightopened: showLeftSidebar && showExploreSidebar
      }"
    >
      <b-row>
        <b-col>
  <div class="panel-body">
    <div class="panel-body_head">
      <b-row class="my-2 justify-content-between">
        <!--<b-col v-if="filterFocused" cols="2" class="d-flex justify-content-start">
          <div
            class="panel-body_chart-type compact active"
          >
            <span v-if="filterFocused"
              >Focusing on: {{ filterFocused.name }}</span
            >
            <span v-else>Focusing on: None</span>
          </div>
          <b-btn
            v-if="filterFocused"
            variant="outline-secondary"
            size="sm"
            @click="clearFocus"
            >Reset</b-btn
          >
        </b-col>-->   
        <b-col
          v-if="
            activeView !== 'new' &&
            activeView !== 'documentstable' &&
            settings !== null
          "
        >
          <b-row
            v-if="showControls && activeBlock !== null"
            class="d-flex align-items-center justify-content-between"
          >
            <b-col>
              <b-form inline class="mt-1 align-items-center">
                <label v-if="showSortZ" class="mr-1">z-Axis</label>
                <b-form-select
                  v-if="showSortZ"
                  v-model="controlValues.sortZ"
                  class="mb-0 mr-2"
                  :options="sortZOptions"
                  size="sm"
                ></b-form-select>

                <label v-if="showColor" class="mr-1">Color</label>
                <b-form-select
                  v-if="showColor"
                  v-model="controlValues.color"
                  class="mb-0 mr-2"
                  :options="colorOptions"
                  size="sm"
                ></b-form-select>

                <label v-if="showSortX" class="mr-1">{{ sortLabel() }}</label>
                <b-form-select
                  v-if="showSortX"
                  v-model="controlValues.sortX"
                  class="mb-0 mr-2"
                  :options="sortXOptions"
                  size="sm"
                ></b-form-select>
                <b-form-select
                  v-if="showSortX && controlValues.sortX !== 'clustering_docs'"
                  v-model="controlValues.sortXDirection"
                  class="mb-0 mr-2"
                  :options="directionOptions"
                  size="sm"
                ></b-form-select>

                <label v-if="showSortY" class="mr-1">Sort y-Axis</label>
                <b-form-select
                  v-if="showSortY"
                  v-model="controlValues.sortY"
                  class="mb-0 mr-2"
                  :options="sortYOptions"
                  size="sm"
                ></b-form-select>
                <b-form-select
                  v-if="showSortY && controlValues.sortY !== 'clustering_docs'"
                  v-model="controlValues.sortYDirection"
                  class="mb-0 mr-2"
                  :options="directionOptions"
                  size="sm"
                ></b-form-select>

                <label v-if="showMetric" class="mr-1">Metric</label>
                <b-form-select
                  v-if="showMetric"
                  v-model="controlValues.metric"
                  class="mb-0 mr-2"
                  :options="colorOptionsSorted"
                  size="sm"
                ></b-form-select>

                <label v-if="showMetricX" class="mr-1">Metric-X</label>
                <b-form-select
                  v-if="showMetricX"
                  v-model="controlValues.metricX"
                  class="mb-0 mr-2"
                  :options="metricXOptions"
                  size="sm"
                ></b-form-select>

                <label v-if="showMetricY" class="mr-1">Metric-Y</label>
                <b-form-select
                  v-if="showMetricY"
                  v-model="controlValues.metricY"
                  class="mb-0 mr-2"
                  :options="metricYOptions"
                  size="sm"
                ></b-form-select>

                <b-form-group v-if="showTypeCats" class="mb-0 mr-2">
                  <b-form-checkbox
                    v-model="controlValues.typeCats"
                    size="sm"
                    switch
                    >Show types &amp; categories</b-form-checkbox
                  >
                </b-form-group>

                <b-form-group v-if="showNormalize" class="mb-0 mr-2">
                  <b-form-checkbox
                    v-model="controlValues.normalizeOverX"
                    size="sm"
                    class="mt-2"
                    switch
                    >Normalize over X</b-form-checkbox
                  >
                </b-form-group>
                <b-btn
                  v-if="activeView !== 'new'"
                  size="sm"
                  variant="danger"
                  class="ml-auto text-overflow-ellipsis"
                  @click="closeTopPanel()"
                  ><i class="fa fa-times"></i> Exit</b-btn
                >
              </b-form>
            </b-col>
          </b-row>
        </b-col>
        <b-col
          v-if="activeBlock === null"
          class="d-flex justify-content-end"
        >
          <!--<b-btn size="sm" variant="info" class="mr-2 ml-2 text-overflow-ellipsis" v-if="activeView !== 'new'" @click="resetFocus">Reset Selection</b-btn>-->
          <b-btn
            v-if="activeView !== 'new' && filterFocused"
            size="sm"
            variant="outline-secondary"
            class="ml-2 text-overflow-ellipsis"
            @click="removeAll"
            ><i class="fa fa-trash"></i> Remove All</b-btn
          >
          <b-btn
            v-if="activeView === 'new'"
            size="sm"
            variant="outline-secondary"
            class="ml-2 text-overflow-ellipsis"
            @click="backTo"
            ><i class="fa fa-back"></i> Cancel</b-btn
          >
          <b-btn
            v-if="activeView === 'new'"
            size="sm"
            variant="primary"
            class="ml-2 text-overflow-ellipsis"
            @click="setQuery"
            ><i class="fa fa-check"></i> Save Visualization</b-btn
          >
        </b-col>
      </b-row>
    </div>

    <div v-if="activeView === 'new'" class="panel-body_content">
      <b-row class="mt-2">
        <b-col cols="4" class="mt-4">
          <b-row>
            <b-col>
              <b-form-group>
                <b-form-checkbox v-model="clustering" size="sm" switch
                  >Clustering</b-form-checkbox
                >
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group>
                <b-form-checkbox v-model="subset" size="sm" switch
                  >Subset</b-form-checkbox
                >
              </b-form-group>
            </b-col>
          </b-row>
        </b-col>
        <b-col cols="8" class="pl-4 pr-4">
          <b-form-group id="input-group-range" class="year-slider">
            <Slider
              v-if="yearRange"
              v-model="yearLimit"
              :min="yearRange[0]"
              :max="yearRange[1]"
            ></Slider>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row class="mt-2">
        <b-col v-for="layout in layoutOptions" :key="layout.value">
          <div
            class="panel-body_chart-type medium"
            :class="{ active: layoutSelected === layout.value }"
            @click="selectType(layout.value)"
          >
            <img :src="'/images/charts/' + layout.icon" />
            <span>{{ layout.text }}</span>
          </div>
        </b-col>
      </b-row>
      <b-row class="mt-2">
        <b-col v-if="layoutSelected !== null">
          <b-form-group
            id="input-name"
            label="Name"
            label-for="input-name"
            class="mb-4"
          >
            <b-form-input
              id="input-name"
              v-model.trim="name"
              v-validate="{ required: true, max: 100 }"
              type="text"
              placeholder="Name"
              size="lg"
              data-vv-name="name"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-desc"
            label="Description"
            label-for="input-desc"
            class="mb-4"
          >
            <b-form-textarea
              id="input-desc"
              v-model.trim="description"
              v-validate="{ required: true, max: 500 }"
              size="lg"
              data-vv-name="description"
              rows="2"
            ></b-form-textarea>
          </b-form-group>
        </b-col>
        <b-col
          v-if="
            layoutSelected !== null &&
            layoutSelected !== 'documentstable' &&
            layoutSelected !== 'worldmap'
          "
        >
          <label size="sm">{{ xLabel() }}</label>
          <ExploreAnalysisCreateAxis
            :axis="axis.x"
            :multiple="false"
          ></ExploreAnalysisCreateAxis>
        </b-col>
        <b-col v-if="['heatmap','clustermap'].includes(layoutSelected)">
          <label size="sm">Y-Axis</label>
          <ExploreAnalysisCreateAxis
            :axis="axis.y"
            :multiple="false"
          ></ExploreAnalysisCreateAxis>
        </b-col>
        <b-col v-if="subset">
          <label size="sm">Z-Axis</label>
          <ExploreAnalysisCreateAxis
            :axis="axis.z"
            :multiple="false"
          ></ExploreAnalysisCreateAxis>
        </b-col>
      </b-row>
    </div>

    <div v-if="activeView !== 'new'" class="panel-body_content">
      <div v-if="activeBlock === null"  class="mx-0 my-2 text-center">
        <b-img src="/images/selection.svg" title="Selection" width="120" class="mb-1"></b-img>  
        <p class="my-2"></p>
        <b-btn
            v-if="activeView !== 'new'"
            size="sm"
            variant="primary"
            class="ml-2 text-overflow-ellipsis"
            @click="changeView('new')"
            ><i class="fa fa-plus"></i> New Visualization</b-btn
          >
        <b-btn
            v-if="activeView !== 'new'"
            size="sm"
            variant="danger"
            class="ml-2 text-overflow-ellipsis"
            @click="closeTopPanel()"
            ><i class="fa fa-times"></i> Exit</b-btn
          >
      </div>
      <h2 v-if="showTitle && activeBlock !== null" class="my-3">
        Update Settings
      </h2>
      <b-row v-if="activeBlock !== null" class="mt-2">
        <b-col cols="5" class="m-2">
          <b-form-group id="input-group-range" class="year-slider">
            <Slider
              v-if="yearRange"
              v-model="yearLimit"
              :min="yearRange[0]"
              :max="yearRange[1]"
            ></Slider>
          </b-form-group>
        </b-col>
        <b-col v-if="showRecency" cols="3" class="m-2 ml-auto">
          <b-form-group
            id="input-group-recency"
            label-for="input-recency"
            class="year-slider"
          >
          <Slider
            v-if="controlValues.recencyRange"
            v-model="controlValues.recencyLimit"
            :decimals="2"
            :min="controlValues.recencyRange[0]"
            :max="controlValues.recencyRange[1]"
            :type="'recency'"
          ></Slider>
          </b-form-group>
        </b-col>
        <b-col v-if="showSize" cols="3" class="m-2">
          <b-form-group
            id="input-group-size"
            label-for="input-size"
            class="year-slider"
          >
          <Slider
            v-if="controlValues.sizeRange"
            v-model="controlValues.sizeLimit"
            :min="controlValues.sizeRange[0]"
            :max="controlValues.sizeRange[1]"
            :type="'size'"
          ></Slider>
          </b-form-group>
        </b-col>
      </b-row>
    </div>
  </div>
        </b-col>
      </b-row>
</div>
</template>

<script>
import _ from "lodash";
import { mapActions, mapState } from "vuex";
import AnalysisHelpers from "@/components/Explore/ExploreAnalysis/AnalysisHelpers";
import { EventBus } from "@/eventBus";
import ExploreAnalysisCreateAxis from "../ExploreAnalysisCreateAxis";
import Slider from "../Slider";

export default {
  name: "DiscoverSettings",
  components: {
    ExploreAnalysisCreateAxis,
    Slider,
  },
  props: {
    settings: {
      type: Object,
      required: false,
      default: null,
    },
  },
  data() {
    return {
      name: null,
      description: null,      
      activeView: 'new',
      activeBlock: null,
      oldAxis: false,
      customAxis: false,
      clustering: false,
      subset: false,
      yearRange: null,
      yearLimit: [],
      years: [],
      axis: {
        x: {},
        y: {},
        z: {},
      },
      layoutTypes: [
        { value: "worldmap", text: "World Map", icon: "global.svg" },
        {
          value: "documentstable",
          text: "Documents Table",
          icon: "listing.svg",
        },
        { value: "heatmap", text: "Heat Map", icon: "grid.svg" },
        //{ value: "clustermap", text: "Cluster Map", icon: "clustermap.svg" },
        //{ value: "onedheatmap", text: "1D Heat Map", icon: "grid.svg" },
        { value: "scatterplot", text: "Scatter Plot", icon: "scatter.svg" },
        { value: "barchart", text: "Bar Chart", icon: "col-chart.svg" },
        { value: "columnchart", text: "Column Chart", icon: "stats.svg" },
        { value: "linechart", text: "Line Chart", icon: "line.svg" },
        { value: "table", text: "Table View", icon: "listing.svg" },
      ],
      layoutSelected: null,
      colorOptions: [
        { value: "size", text: "Size" },
        { value: "recency", text: "Recency" },
      ],
      sortZOptions: [{ value: 0, text: "All" }],
      metricXOptions: [
        { value: "size", text: "Size" },
        { value: "recency", text: "Recency" },
      ],
      metricYOptions: [
        { value: "size", text: "Size" },
        { value: "recency", text: "Recency" },
      ],
      directionOptions: [
        { value: "asc", text: "Ascending" },
        { value: "des", text: "Descending" },
      ],
      showTitle: true,
      showControls: true,
      showQuery: false,
      showColor: true,
      showSortZ: true,
      showSortX: true,
      showSortY: false,
      showNormalize: true,
      showRecency: true,
      showSize: true,
      showMetric: true,
      showMetricX: true,
      showMetricY: true,
      showTypeCats: true,
      controlValues: {
        color: "size",
        metric: "size",
        sortX: "size",
        sortXDirection: "dsc",
        sortY: "size",
        sortYDirection: "dsc",
        sortZ: 0,
        metricX: "recency",
        metricY: "size",
        typeCats: true,
        normalizeOverX: false,
        sizeLimit: [0, 10],
        sizeRange: [0, 10],
        recencyLimit: [0, 10],
        recencyRange: [0, 10],
      },
    };
  },
  computed: {
    ...mapState({
      documentsPerYear: (state) => state.document.documentsPerYear,
      filterFocused: (state) => state.filter.filterFocused,
      indices: (state) => state.ttc.indices,
      metas: (state) => state.ttc.metas,
      subsetFilter: (state) => state.filter.subsetFilter,
    }),
    layoutOptions() {
      if (this.metas["Location"] || this.metas["Country"] || this.metas["Country Code"]) {
        return this.layoutTypes;
      }
      return this.layoutTypes.filter((t) => t.value !== "worldmap");
    },
    ringStringified: {
      get() {
        return JSON.stringify(this.ring);
      },
      set(val) {
        this.query = JSON.parse(val);
      },
    },
    colorOptionsSorted() {
      const generalOptions = [];
      const filterOptions = [];

      this.colorOptions.forEach((o) => {
        if (o.text.includes("filter")) {
          filterOptions.push(o);
        } else {
          generalOptions.push(o);
        }
      });

      if (filterOptions.length > 0) {
        return [
          { text: "General", value: null, disabled: true },
          ...generalOptions,
          { text: "Filter", value: null, disabled: true },
          ...filterOptions,
        ];
      }

      return generalOptions;
    },
    sortXOptions() {
      return [
        { value: "normal", text: "Normal" },
        { value: "size", text: "Size" },
        { value: "filtsize", text: "Size (Filter)", disabled: !this.filterFocused },
        { value: "recency", text: "Recency" },
        { value: "filtrecency", text: "Recency (Filter)", disabled: !this.filterFocused },
        { value: "clustering", text: "Clustering", disabled: !this.clustering },
        { value: "clustering", text: "Clustering", disabled: !this.clustering },
        {
          value: "clustering_docs",
          text: "Clustering (Documents)",
          disabled: !this.clustering,
        },
      ];
    },
    sortYOptions() {
      return [
        { value: "normal", text: "Normal" },
        { value: "size", text: "Size" },
        { value: "filtsize", text: "Size (Filter)", disabled: !this.filterFocused },
        { value: "recency", text: "Recency" },
        { value: "filtrecency", text: "Recency (Filter)", disabled: !this.filterFocused },
        { value: "clustering", text: "Clustering", disabled: !this.clustering },
        {
          value: "clustering_docs",
          text: "Clustering (Documents)",
          disabled: !this.clustering,
        },
      ];
    },
  },
  watch: {
    yearLimit(value) {
      if (this.years[0] !== value[0]) {
        this.years[0] = value[0];
        this.updateSettings();
      }
      if (this.years[1] !== value[1]) {
        this.years[1] = value[1];
        this.updateSettings();
      }
      if (this.years[2] !== value[2]) {
        this.years[2] = value[2];
        this.updateSettings();
      }
    },
    settings: {
      handler(value, old){
        //console.log(value);
        if (value === null) {
          this.activeView = 'new';
          this.activeBlock = null;
        }
        else{
          this.layoutSelected = value.view;
          this.activeView = value.view;
          this.activeBlock = value.block;
          this.controlValues.color = value.color;
          this.colorOptions = value.colorOptions;
          this.controlValues.metric = value.metric;
          this.controlValues.sortZ = value.sortZ;
          this.sortZOptions = value.sortZOptions;
          this.clustering = value.clustering;
          this.controlValues.sortX = value.sortX.includes("_")? value.sortX.split("_")[0]:value.sortX;
          this.controlValues.sortXDirection = value.sortX.includes("_")? value.sortX.split("_")[1]:"des";
          this.controlValues.sortY = value.sortY && value.sortY.includes("_")? value.sortY.split("_")[0]:value.sortY;
          this.controlValues.sortYDirection = value.sortY && value.sortY.includes("_")? value.sortY.split("_")[1]:"des";
          this.controlValues.sizeLimit = value.sizeLimit;
          this.controlValues.recencyLimit = value.recencyLimit;
          this.controlValues.sizeRange = value.sizeRange;
          this.controlValues.recencyRange = value.recencyRange;
          this.controlValues.metricX = value.metricX;
          this.metricXOptions = value.metricXOptions;
          this.controlValues.metricY = value.metricY;
          this.metricYOptions = value.metricYOptions;
          this.controlValues.typeCats = value.typeCats;

          this.showTitle = value.controls.showTitle;
          this.showControls = value.controls.showControls;
          this.showQuery = value.controls.showQuery;
          this.showColor = value.controls.showColor;
          this.showSortZ = value.controls.showSortZ;
          this.showSortX = value.controls.showSortX;
          this.showSortY = value.controls.showSortY;
          this.showNormalize = value.controls.showNormalize;
          this.showRecency = value.controls.showRecency;
          this.showSize = value.controls.showSize;
          this.showMetric = value.controls.showMetric;
          this.showMetricX = value.controls.showMetricX;
          this.showMetricY = value.controls.showMetricY;
          this.showTypeCats = value.controls.showTypeCats;
        }
      },
      deep: true
    },
    controlValues: {
      handler: function () {
        //console.log("Settings updated from top panel");
        this.updateSettings();
      },
      deep: true,
    },
    /*controlValues() {
      this.updateSettings();
    },*/
  },
  mounted() {
    this.initAxis();
    this.initYears();
        if (this.settings === null) {
          this.activeView = "new";
          this.activeBlock = null;
        }
        else{
          let value = this.settings;
          this.layoutSelected = value.view;
          this.activeView = value.view;
          this.activeBlock = value.block;
          this.controlValues.color = value.color;
          this.colorOptions = value.colorOptions;
          this.controlValues.metric = value.metric;
          this.controlValues.sortZ = value.sortZ;
          this.sortZOptions = value.sortZOptions;
          this.clustering = value.clustering;
          this.controlValues.sortX = value.sortX &&value.sortX.includes("_")? value.sortX.split("_")[0]:value.sortX;
          this.controlValues.sortXDirection = value.sortX && value.sortX.includes("_")? value.sortX.split("_")[1]:"des";
          this.controlValues.sortY = value.sortY && value.sortY.includes("_")? value.sortY.split("_")[0]:value.sortY;
          this.controlValues.sortYDirection = value.sortY && value.sortY.includes("_")? value.sortY.split("_")[1]:"des";
          this.controlValues.sizeLimit = value.sizeLimit;
          this.controlValues.recencyLimit = value.recencyLimit;
          this.controlValues.sizeRange = value.sizeRange;
          this.controlValues.recencyRange = value.recencyRange;
          this.controlValues.metricX = value.metricX;
          this.metricXOptions = value.metricXOptions;
          this.controlValues.metricY = value.metricY;
          this.metricYOptions = value.metricYOptions;
          this.controlValues.typeCats = value.typeCats;

          this.showTitle = value.controls.showTitle;
          this.showControls = value.controls.showControls;
          this.showQuery = value.controls.showQuery;
          this.showColor = value.controls.showColor;
          this.showSortZ = value.controls.showSortZ;
          this.showSortX = value.controls.showSortX;
          this.showSortY = value.controls.showSortY;
          this.showNormalize = value.controls.showNormalize;
          this.showRecency = value.controls.showRecency;
          this.showSize = value.controls.showSize;
          this.showMetric = value.controls.showMetric;
          this.showMetricX = value.controls.showMetricX;
          this.showMetricY = value.controls.showMetricY;
          this.showTypeCats = value.controls.showTypeCats;
        }
  },
  methods: {
    ...mapActions(["saveSubsetFilter", "filterFocus"]),
    initAxis() {
      ["x", "y", "z"].forEach((d) => {
        this.axis[d] = {
          dimension: d,
          levels: [
            {
              id: 1,
              modifiers: [],
              grouped: false,
              includeAll: false,
              linked: false,
              layers: [],
            },
          ],
        };
      });
    },
    initYears() {
      if (this.documentsPerYear.length > 0) {
        const yearMin = parseInt(_.minBy(this.documentsPerYear, "year").year);
        const yearMax = parseInt(_.maxBy(this.documentsPerYear, "year").year);
        this.yearRange = [yearMin, yearMax];
        this.yearLimit = [yearMin, yearMax - 2, yearMax];
        this.years = this.yearLimit;
      }
    },
    buildQueryLayers(axis) {
      const preselect = { 
        //max: 1000, 
        overlap: false 
      };
      return AnalysisHelpers.buildQueryLayers(axis, preselect);
    },
    setQuery() {
      if (this.layoutSelected === "worldmap") {
        let country = "";
        if(this.metas["Country"]){
          country = this.metas["Country"][0][0];
        }
        else if(this.metas["Country Code"]){
          country = this.metas["Country Code"][0][0];
        }
        else if(this.metas["Location"]){
          country = this.metas["Location"][0][0];
        }
        else{
          country = "scopuscountry";
        }
        this.axis.x.levels.length = 1;
        this.axis.x.levels[0].grouped = false;
        this.axis.x.levels[0].includeAll = false;
        this.axis.x.levels[0].layers = [
          {
            label: "Country",
            value: [country, 0],
            searchable: true,
          },
        ];
      }
      if (!_.isEmpty(this.axis.x)) {
        if (this.axis.x.levels.length === 0) {
          this.$toasted.show("Please Define Level(s)", { type: "error" });
        } else {
          let query = {
            xlayers: this.buildQueryLayers(this.axis.x),
            zlayers: this.subset ? this.buildQueryLayers(this.axis.z) : [null],
            subset_filters:
              this.subsetFilter.length > 0 ? [this.subsetFilter] : [],
            startyear: this.years[0],
            recentyear: this.years[1],
            stopyear: this.years[2],
            postprocessing: this.clustering ? ["clustering"] : [],
          };
          if (!_.isEmpty(this.axis.x)){
            query.ylayers = this.buildQueryLayers(this.axis.y);
          }
          this.$emit("initNewBlock", [query, this.layoutSelected, {name: this.name, description: this.description}]);
          this.resetSettings();
        }
      }
      this.activeView = "new";
      this.$emit("closeTopPanel");
      //EventBus.$emit("toggleTopPanel", null);
    },
    selectType(type) {
      //console.log(type);
      if (this.layoutSelected !== type) {
        this.layoutSelected = type;
        type === 'heatmap'?
          this.clustering = true
          :this.clustering = false
      } else {
        this.layoutSelected = null;
        this.clustering = false;
      }
    },
    resetSettings() {
      this.initAxis();
      this.initYears();
      this.layoutSelected = null;
    },
    removeAll() {
      EventBus.$emit("removeAll");
    },
    backTo() {
      this.activeBlock = null;
      this.activeView = 'new';
      this.$emit("closeTopPanel");
    },
    changeView(view) {
      /*if (!this.filterFocused) {
        this.$toasted.show(
          "Nothing in Focus! You need to focus on anything to add new visualization",
          { type: "error" }
        );
      } else {*/
        if (view !== this.activeView) {
          this.activeView = view;
          EventBus.$emit("toggleTopPanel", view);
        }
      //}
    },
    changeLayout(layout) {
      this.$emit("changeLayout", layout);
      this.selectType(layout);
    },
    updateSettings() {
      let sortX = this.controlValues.sortX;
      if (
        sortX !== "clustering" &&
        sortX !== "clustering_docs" &&
        this.controlValues.sortXDirection === "des"
      ) {
        sortX += "_des";
      }
      let sortY = this.controlValues.sortY;
      if (
        sortY !== "clustering" &&
        sortY !== "clustering_docs" &&
        this.controlValues.sortYDirection === "des"
      ) {
        sortY += "_des";
      }

      this.$emit("updateSettings", {
        view: this.activeView,
        block: this.activeBlock,
        metric: this.controlValues.metric,
        color: this.controlValues.color,
        colorOptions: this.colorOptions,
        sortX: sortX,
        sortY: sortY,
        sortZ: this.controlValues.sortZ,
        sortZOptions: this.sortZOptions,
        normalizeOverX: this.controlValues.normalizeOverX,
        sizeLimit: this.controlValues.sizeLimit,
        recencyLimit: this.controlValues.recencyLimit,
        sizeRange: this.controlValues.sizeRange,
        recencyRange: this.controlValues.recencyRange,
        metricX: this.controlValues.metricX,
        metricY: this.controlValues.metricY,
        typeCats: this.controlValues.typeCats,
        years: this.years,
      });
    },
    xLabel(){
      if(this.layoutSelected === 'columnchart' || this.layoutSelected === 'heatmap'){
        return 'X-Axis'
      }
      else if(this.layoutSelected === 'barchart'){
        return 'Y-Axis'
      }
      else{
        return ''
      }
    },
    sortLabel(){
      if(this.activeView === 'columnchart'){
        return 'Sort x-Axis'
      }
      else if(this.activeView === 'barchart'){
        return 'Sort y-Axis'
      }
      else{
        return 'Sort Axis'
      }
    },
    closeTopPanel(){
      this.activeBlock = null;
      this.activeView = 'new';
      this.$emit("closeTopPanel");
    },
    clearFocus() {
      this.filterFocus({ filter: null, type: this.filterFocused.type });
    },
  },
};
</script>
